var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10629",
    "data-name": "Group 10629",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.771,
    height: 14.744,
    viewBox: "0 0 14.771 14.744",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2979",
    "data-name": "Rectangle 2979",
    width: 14.771,
    height: 14.744,
    fill: "#e6f0f3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10627",
    "data-name": "Group 10627",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28429",
    "data-name": "Path 28429",
    d: "M11.06,9.792a1.471,1.471,0,0,0-2.088,0l-.711.711A12.861,12.861,0,0,1,6.045,8.725,13.219,13.219,0,0,1,4.267,6.51L4.978,5.8a1.471,1.471,0,0,0,0-2.088L3.589,2.323a1.439,1.439,0,0,0-1.036-.432,1.484,1.484,0,0,0-1.047.432l-.668.663A3.13,3.13,0,0,0,.032,5.565a10.417,10.417,0,0,0,3.227,5.926,10.585,10.585,0,0,0,5.946,3.247,3.6,3.6,0,0,0,.412,0,2.984,2.984,0,0,0,2.167-.806l.663-.668a1.484,1.484,0,0,0,.432-1.047,1.439,1.439,0,0,0-.432-1.036Zm.694,2.779-.668.663a2.243,2.243,0,0,1-1.8.491,9.526,9.526,0,0,1-5.31-2.948A9.636,9.636,0,0,1,1.015,5.483a2.224,2.224,0,0,1,.491-1.8L2.2,3.016a.5.5,0,0,1,.7,0L4.287,4.421a.5.5,0,0,1,0,.694L3.3,6.1a.488.488,0,0,0-.079.593,13.459,13.459,0,0,0,2.126,2.74A13.474,13.474,0,0,0,8.095,11.56a.491.491,0,0,0,.593-.079l.983-.983a.494.494,0,0,1,.693,0l1.39,1.389a.5.5,0,0,1,.143.351.483.483,0,0,1-.143.332m.854-10.414A7.322,7.322,0,0,0,7.4,0a.491.491,0,1,0,0,.983,6.391,6.391,0,0,1,6.387,6.44.491.491,0,1,0,.983,0,7.323,7.323,0,0,0-2.162-5.266",
    transform: "translate(0 0)",
    fill: "#e6f0f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28430",
    "data-name": "Path 28430",
    d: "M13.63,6.6a2.96,2.96,0,0,1,.87,2.118.491.491,0,0,0,.983,0,3.932,3.932,0,0,0-3.93-3.981.491.491,0,1,0,0,.983,2.958,2.958,0,0,1,2.078.88",
    transform: "translate(-3.816 -1.635)",
    fill: "#e6f0f3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTellIcon);
export default __webpack_public_path__ + "static/media/tell_icon.edb14361981e194391204fd348a7cc7f.svg";
export { ForwardRef as ReactComponent };